import { getPath } from '@/router/common'

const baseUrl = {
  title: '催款管理',
  path: 'PressForMoney'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'PressForMoney_Index',
    component: () => import(/* webpackChunkName: "PressForMoney_Index" */ '@/views/pressForMoney/index/index.vue'),
    meta: {
      title: '催款管理'
    }
  },
  {
    path: getPath('PressForMoneyAdd', baseUrl),
    name: 'PressForMoney_PressForMoneyAdd',
    component: () => import(/* webpackChunkName: "PressForMoney_PressForMoneyAdd" */ '@/views/pressForMoney/pressForMoneyAdd/index.vue'),
    meta: {
      title: '催款办理'
    }
  },
  {
    path: getPath('SimulationHxAdd', baseUrl),
    name: 'PressForMoney_SimulationHxAdd',
    component: () => import(/* webpackChunkName: "PressForMoney_SimulationHxAdd" */ '@/views/pressForMoney/simulationHxAdd/index.vue'),
    meta: {
      title: '模拟已收-新增'
    }
  },
  {
    path: getPath('SimulationHxEdit', baseUrl),
    name: 'PressForMoney_SimulationHxEdit',
    component: () => import(/* webpackChunkName: "PressForMoney_SimulationHxEdit" */ '@/views/pressForMoney/simulationHxEdit/index.vue'),
    meta: {
      title: '模拟已收-修改'
    }
  },
  {
    path: getPath('handleLog', baseUrl),
    name: 'PressForMoney_handleLog',
    component: () => import(/* webpackChunkName: "PressForMoney_handleLog" */ '@/views/pressForMoney/handleLog/index.vue'),
    meta: {
      title: '加锁解锁日志|预收款调整日志|模拟核销日志'
    }
  }
]
